<template>
  <div class="slider" v-if="items_slider.length >= 6">
    <div class="items">
       <carousel
      :dots="false"
      :center="false"
      :nav="false"
      :responsive="{
        0: { items: 1, nav: false },
        800: { items: 2, nav: false },
        1300: { items: 3, nav: false },
        2000: { items: 4, nav: false },
      }"
      :loop="false"
    >
      <template slot="prev"
        ><span class="btn-prev"><i class="fa fa-caret-left"></i></span
      ></template>

      <template slot="next"
        ><span class="btn-next"><i class="fa fa-caret-right"></i></span
      ></template>
      <template>
        <CardMin
          v-for="(item, index) in items_slider"
          :key="index"
          :title="item.name"
          :link="item.link"
          :description="item.description"
          :photo="item.image"
        />
      </template>
    </carousel>
    </div>
   
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import CardMin from "../components/CardMin";
export default {
  name: "SliderBottom",
  components: {
    carousel,
    CardMin,
  },
  data: () => ({
    items_slider: [],
  }),
  mounted: async function () {
    if (this.$store.getters.items_slider.length == 0) {

      await this.$axios
        .all([
          this.$axios.get("jogo/destaques"),
          this.$axios.get("jogo/banca"),
          this.$axios.get("jogo/torneios"),
        ])
        .then(
          this.$axios.spread(async (destaquesRes, bancaRes, torneiosRes) => {
            await destaquesRes.data.map(async (el) => {
              if (el.passatempos[0]!= undefined)
                await this.items_slider.push({
                  name: el.nome_fantasia,
                  id: el.id,
                  image: el.passatempos[0].edicoes.foto,
                  description: el.passatempos[0].subtitulo,
                  link: `/passatempos/${el.nome_fantasia}/${el.id}`
                });
            });


            await this.items_slider.push({
                  name: "Banca",
                  id: bancaRes.data[0].id,
                  image: bancaRes.data[0].foto,
                  description: bancaRes.data[0].subtitulo,
                  link: `/banca/`
                });
            await this.items_slider.push(
              {
                  name:  "Torneios",
                  id: torneiosRes.data[0].id,
                  image: torneiosRes.data[0].foto,
                  description: torneiosRes.data[0].subtitulo,
                  link: `/torneios/`
                }
            );

            this.$store.commit("setItemsSlider", this.items_slider);
          })
        )
        .catch(() => {
        });
    } else {
      this.items_slider = this.$store.getters.items_slider;
    }
  },
};
</script>

<style lang="css" scoped>
.slider {
    position: relative;

}

.slider .items{
  padding-top: 3vh;
  height: 20vh;
}


.btn-next {
  position: absolute;
  top: 0;
  right: 0px;
  color: black;
  font-size: 25px;
  color: black;
  outline: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  border: none;
  width: 50px;
  cursor: pointer;
}

.btn-prev {
  position: absolute;
  top: 0;
  height: 100%;
  width: 50px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  font-size: 25px;
  z-index: 99999;
  color: black;
  outline: 0;
  border: none;
  cursor: pointer;
}
</style>